import { render, staticRenderFns } from "./SearchStudentDiscountReport.vue?vue&type=template&id=ab76d8ae&scoped=true&"
import script from "./SearchStudentDiscountReport.vue?vue&type=script&lang=js&"
export * from "./SearchStudentDiscountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab76d8ae",
  null
  
)

export default component.exports